import { useEnvironment } from 'services/environment';
import { useContext } from 'react';
import { MicrositeContext } from 'context';
import { MOVING_APP_BUYFLOW_PATH } from 'constants/movingApp';

export function useMicrositeMovingAppBuyflowUrl(): string | undefined {
  const { name: envName, localBuyflowBaseUrl } = useEnvironment();
  const micrositeConfig = useContext(MicrositeContext);

  if (envName === 'development' && localBuyflowBaseUrl) {
    return `${localBuyflowBaseUrl}${MOVING_APP_BUYFLOW_PATH}`;
  }

  if (micrositeConfig.appUrl) {
    return `${micrositeConfig.appUrl}${MOVING_APP_BUYFLOW_PATH}`;
  }

  if (
    'movingAppBuyflowUrls' in micrositeConfig &&
    micrositeConfig.movingAppBuyflowUrls
  ) {
    const url = micrositeConfig.movingAppBuyflowUrls?.[envName.toString()];

    if (url === undefined) {
      throw new Error(
        `[useMicrositeMovingAppBuyflowUrl] No URL configured for environment: ${envName}`
      );
    }

    return url;
  }

  return undefined;
}

export function useUpdaterCrossSellUrl(): string {
  const { name: envName } = useEnvironment();
  let url;
  switch (envName) {
    case 'development':
      url = 'http://bridgevine.io:4200/provider';
      break;
    case 'staging':
    case 'qa':
      url = 'https://staging-cart.updater.com/provider';
      break;
    case 'production':
    default:
      url = 'https://cart.updater.com/provider';
      break;
  }
  return url;
}
